import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getColors, rounded } from '../theme/tokens';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  body?: React.ReactNode;
  action?: React.ReactNode;
}

/** Notion ex-empty-state-card: soft canvas frame, generous padding. */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, body, action }) => {
  const theme = useTheme();
  const c = getColors(theme.palette.mode);
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 7,
        px: 3,
        borderRadius: `${rounded.xl}px`,
        backgroundColor: c.canvasSoft,
        border: `1px solid ${c.hairline}`,
      }}
    >
      {icon && <Box sx={{ mb: 1.5, opacity: 0.35, '& svg': { fontSize: 44 } }}>{icon}</Box>}
      <Typography sx={{ fontWeight: 600, fontSize: '1.05rem', color: c.inkSecondary, mb: 0.5 }}>
        {title}
      </Typography>
      {body && (
        <Typography variant="body2" sx={{ color: c.inkMuted, maxWidth: 440, mx: 'auto', mb: action ? 2 : 0 }}>
          {body}
        </Typography>
      )}
      {action}
    </Box>
  );
};

export default EmptyState;
